import styled from 'styled-components';

export const PaginationContainer = styled.div`
  text-align: center;
  margin-top: 10px;
  margin-bottom: 30px;
`;
